/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Ad_Ai_Tools_TitleInputs */



/**
* | output |
* | --- |
* | "AI Authoring Tools" |
*
* @param {Event_Ad_Ai_Tools_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_ad_ai_tools_title = /** @type {((inputs?: Event_Ad_Ai_Tools_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Ad_Ai_Tools_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Outils de creation IA")
	if (locale === "de") return /** @type {LocalizedString} */ ("KI-Autorenwerkzeuge")
	if (locale === "it") return /** @type {LocalizedString} */ ("Strumenti di creazione di intelligenza artificiale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Инструменты для создания контента с использованием ИИ")
	if (locale === "es") return /** @type {LocalizedString} */ ("Herramientas de creación de IA")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("人工智能创作工具")
	if (locale === "ja") return /** @type {LocalizedString} */ ("AIオーサリングツール")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एआई ऑथरिंग टूल्स")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ferramentas de autoria de IA")
	return /** @type {LocalizedString} */ ("AI Authoring Tools")
});